import { config as configuration } from "./production";

export const config = configuration
